export const Options = {
    BecomingAwareThrough: [
        { text:"LinkedIn",value:"LinkedIn"},
        { text:"Online-Jobbörsen (z.B. Stepstone, Indeed)",value:"Online-Jobbörsen (z.B. Stepstone, Indeed)"},
        { text:"Jobmessen/Veranstaltungen",value:"Jobmessen/Veranstaltungen"},
        { text:"Aushang an Universität",value:"Aushang an Universität"},
        { text:"Printmedien (z.B. Karrieremagazin)", value:"Printmedien (z.B. Karrieremagazin)"},
        { text:"Kontakt zum Unternehmen",value:"Kontakt zum Unternehmen"},
        { text:"Mitarbeiterempfehlung",value:"Mitarbeiterempfehlung"},
        { text:"BET-Karriereseite", value:"BET-Karriereseite"},
        { text:"Sonstiges",value:"Sonstiges"},
    ],
    PreferredLocation: [
        "Aachen",
        "Berlin",
        "Leipzig",
    ]
}
